import hgmsdk from './hgmsdk.js';
import vue from '../../main'
/**
 * @description 该对象的所有属性均为原生的回调方法
 * @author kongxiangcheng 2022.07.06
 */
let callBack = {
  /**
   * @function 预览文件方法回调
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  previewFile: function(res) {
    window.previewFile = function(val) {
      res(val)
    }
  },
  /**
   * @function 签名方法回调(不推荐使用！！！！！！！！！！！！！！)
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  mobileShieldSign: function(res) {
    window.signatureData = function(val) {
      res(Array.from(arguments))
    }
  },
  /**
   * @function 签名方法回调(推荐使用！！！！！！！！！！！！)
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  signatureData: function(res) {
    window.signatureDataResult = function(val) {
      res(val)
    }
  },
  /**
   * @function 扫码方法回调
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  scanQR: function(res) {
    window.scanQRResult = function(val) {
      res(val)
    }
  },
  /**
   * @function 定位方法回调
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  getLocation: function(res) {
    window.resultLocation = function(val) {
      res(val)
    }
  },
    /**
     * @function 参加视频会议方法回调
     * @returns {Object}
     * @author songyuhui 2024.12.12
     */
    joinMeeting: function(res) {
      window.joinMeetingResult = function(val) {
        res(val)
      }
    },
  /**
   * @function 获取图片回调
   * @returns {Object}
   * @author kongxiangcheng 2022.07.06
   */
  getImage: function(res) {
    window.resultImages = function(val) {
      let data = JSON.parse(val)
	  console.log(val.substring(0,100))
	  console.log(val.length)
      res(data)
    }
  },
  getAppType: function(res) {
    window.appTypeResult = function(val) {
      res(val)
    }
  },
  getFileContent: function(res) {
    window.fileContentResult = function(val) {
      res(val)
    }
  },
  SM4SymEnDecrypt: function (res) {
    window.resultSM4SymEnDecrypt = function (val) {
      res(val)
    }
  },
  openPaymentApp: function (res) {
    window.openPaymentAppResult = function (val) {
      res(val)
    }
  },
  launchApp: function (res) {
    window.launchAppResult = function (val) {
      res(val)
    }
  },  
  getDeviceInfo: function (res) {
    window.getDeviceInfoResult = function (val) {
		if(typeof val == 'string'){
			res(JSON.parse(val))
		}else{
			res(val)
		}
    }
  },
  openWebView: function (res) {
    window.openWebViewResult = function (val) {
		if(typeof val == 'string'){
			res(JSON.parse(val))
		}else{
			res(val)
		}
    }
  },
  
}

/**
 * @function 拼接调用原生方法和回调函数
 * @description 单一使用
 * @param name {String} 原生和回调方法名
 * @param keys {String} 原生入参
 * @returns {Promise}
 * @author kongxiangcheng 2022.07.06
 */
function swNative(name, keys) {
  console.log('执行swNative',name,keys)
  let systemType = getSystemType()
  let p = new Promise((res) => {
    callBack[name](res)
  })
  try {
    if (keys == undefined) {
      switch (systemType) {
        case '1':
          window.webkit.messageHandlers[name].postMessage('');
          break
        case '2':
          javascript: android[name]();
          break
      }
    } else {
      switch (systemType) {
        case '1':
		  console.log('3.执行原生',name)
		  console.log(keys)
          window.webkit.messageHandlers[name].postMessage(keys);
          break
        case '2':
          console.log('2.执行安卓原生',name,'keys:',keys)
          javascript: android[name](keys);
          break
      }
    }
  } catch (e) {
    localStorage.setItem('swNativecatchLog', e)
    console.log('联系运维人员', e)
  }
  return p
}
/**
 * @description 该对象的所有属性均为调用原生方法
 * @author kongxiangcheng 2022.07.06
 */
export let native = {
  /**
   * @function getAppType()
   * @description 获取应用类型
   * @params data {number} 1:单一;2.海关
   * @author kongxiangcheng 2022.07.06
   */
  appType: getAppType(),
  /**
   * @function 去原生登录页
   * @description 
   * @returns {viod}
   * @author ningwenlei 2025/10/21
   */
   jumpLogin: function(obj) {
    let p = ''
    console.log('-----')
    console.log(this.appType,'这个是什么')
    switch (this.appType) {
      case '1':
        return swNative('jumpLogin',obj)
      case '2':
        //HG
    }
  },
  /**
   * @function 去原生首页
   * @description 
   * @returns {viod}
   * @author ningwenlei 2025/10/21
   */
   jumpHomePage: function(obj) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('jumpHomePage',obj)
      case '2':
        //HG
    }
  },
  /**
   * @function 加签(不推荐使用！！！！！！！！！！！！！！)
   * @description 根据不同的nativeApiType调用不同的原生
   * @param keys {String}原生入参
   * @returns {viod}
   * @author kongxiangcheng 2022.07.06
   */
  signData: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('mobileShieldSign', keys)
      case '2':
        p = new Promise((res) => {
          HGFile.signData(keys, function(result) {
            res(result)
          });
        })
        return p
    }
  },
  /**
   * @function 加签(推荐使用！！！！！！！！！！！！)
   * @description 根据不同的nativeApiType调用不同的原生
   * @param keys {String}原生入参
   * @returns {viod}
   * @author kongxiangcheng 2023.08.22
   */
  signatureData: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('signatureData', keys)
      case '2':
        p = new Promise((res) => {
          HGFile.signData(keys, function(result) {
            res(result)
          });
        })
        return p
    }
  },
  /**
   * @function 预览文件
   * @description 根据不同的nativeApiType调用不同的原生
   * @param keys {String}原生入参
   * @returns {viod}
   * @author kongxiangcheng 2022.07.06
   */
  previewFile: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('previewFile', keys)
      case '2':
        p = new Promise((res) => {
          hgmsdk.HGFile.previewFileWithCas(params, function(result) {
            res(result)
          })
        })
        return p
    }
  },
  /**
   * @function 扫描二维码
   * @description 根据不同的nativeApiType调用不同的原生
   * @returns {viod}
   * @author kongxiangcheng 2022.07.06
   */
  scanQR: function() {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('scanQR')
      case '2':
        p = new Promise((res) => {
          HGFile.scanQR(function(result) {
            res(result)
          });
        })
        return p
    }
  },
  /**
   * @function 定位
   * @description 根据不同的nativeApiType调用不同的原生
   * @returns {viod}
   * @author kongxiangcheng 2022.07.06
   */
  getLocation: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('getLocation', keys)
      case '2':
        p = new Promise((res) => {
          hgmsdk.HGDeviceInfo.getLocation(keys, function(result) {
            res(result);
          });
        });
        return p;
    }
  },
    /**
     * @function 参加视频会议
     * @description 根据不同的nativeApiType调用不同的原生
     * @returns {viod}
     * @author kongxiangcheng 2022.07.06
     */
    joinMeeting: function(keys) {
      let p = ''
      switch (this.appType) {
        case '1':
          return swNative('joinMeeting', keys)
        case '2':
          p = new Promise((res) => {
            hgmsdk.HGMeeting.joinMeeting(keys, function(result) {
              res(result);
            });
          });
          return p;
      }
    },
  /**
   * @function 获取图片
   * @description 根据不同的nativeApiType调用不同的原生
   * @returns {viod}
   * @author kongxiangcheng 2022.07.06
   */
  getImage: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
		console.log('2.执行swNative（）')
        return swNative('getImage', keys)
      case '2':
        p = new Promise((res) => {
          hgmsdk.HGCamera.getImage(keys, function(result) {
            let data = JSON.parse(result)
            res(data);
          });
        });
        return p;
    }
  },
  /**
   * @function 返回首页接口
   * @description
   * @param keys {obj} 返回任意路由地址（单一使用）
   * @returns void
   * @author kongxiangcheng 2022.07.19
   */
  goPage: function(keys) {
    switch (this.appType) {
      case '1':
        console.log('goPage')
        vue.$router.go(keys.router);
        break
      case '2':
        window.close()
        break
    }
  },
  /**
   * @function 获取文件内容接口
   * @description
   * @param keys {String}原生入参
   * @returns Promise
   * @author kongxiangcheng 2022.09.13
   */
  getFileContent: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('getFileContent', keys)
      case '2':
        p = new Promise((res) => {
          hgmsdk.HGFile.getFileContent(keys, function(result) {
            res(result);
          });
        });
        return p;
    }
  },
  /**
   * @function SM4加解密接口
   * @description
   * @param keys {String}原生入参
   * @returns Promise
   * @author kongxiangcheng 2022.09.13
   */
  SM4SymEnDecrypt: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('SM4SymEnDecrypt', keys)
      case '2':
        p = new Promise((res) => {
          hgmsdk.HGEnDecrypt.SM4SysEnDecrypt(keys, function(result) {
            res(result);
          });
        });
        return p;
    }
  },
   /**
   * @function 原生支付接口
   * @description
   * @param keys {String}原生入参
   * @returns Promise
   * @author kongxiangcheng 2023.06.19
   */
  launchApp: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('launchApp', keys)
	  //case '2':等待掌上海关开发
    }
  },
  /**
   * @function 获取设备信息
   * @description
   * @returns Promise
   * @author kongxiangcheng 2025.09.11
   */
  getDeviceInfo: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('getDeviceInfo', keys)
	  case '2':
        p = new Promise((res) => {
          hgmsdk.HGDeviceInfo.getDeviceInfo(params, function(result) {
            res(result)
          })
        })
        return p
    }
  },
  
  /**
   * @function 唤醒第三方APP
   * @description
   * @param keys {String}原生入参
   * @returns Promise
   * @author kongxiangcheng 2023.06.19
   */
  openPaymentApp: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('openPaymentApp', keys)
	  case '2':
	    p = new Promise((res) => {
          hgmsdk.HGPay.openPaymentApp(keys, function(result) {
            res(result);
           });
        });
        return p;
    }
  },
    /**
   * @function 打开新的webview窗口
   * @description
   * @param keys {String}原生入参
   * @returns Promise
   * @author kongxiangcheng 2025.12.05
   */
  openWebView: function(keys) {
    let p = ''
    switch (this.appType) {
      case '1':
        return swNative('openWebView', keys)
	  case '2':
	    
    }
  },
};
/**
 * @function 判断APP类型
 * @description 调用原生接口进行判定，对native.appType赋值
 * @returns {viod}
 * @author kongxiangcheng 2022.07.06
 */
function getAppType() {
  console.log('调用getAppType()')
  swNative('getAppType').then((data) => {
    console.log('app回调类型', data)
    native.appType = data.toString();
  })
}


/**
 * @function 判断手机操作类型
 * @returns {string} 1:ios系统;2:Android系统;3:其他系统
 * @author kongxiangcheng 2022.07.06
 */
function getSystemType() {
  console.log('----base----')
  let u = navigator.userAgent
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  if (isiOS) {
    return '1'
  } else if (isAndroid) {
    return '2'
  } else {
    return '3'
  }
}